import { render, staticRenderFns } from "./SelectYearSemester.vue?vue&type=template&id=177d22b7&"
import script from "./SelectYearSemester.vue?vue&type=script&lang=js&"
export * from "./SelectYearSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports